import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { SanitizedField } from 'models';
import type { RootState } from 'reducers/types';
import {
  isCashfreeOfferSelected,
  isLulu,
  isLuluOfferSelected,
} from 'selectors';
import { useTranslations } from 'utils';

import { TextInputField } from '../TextInputField/TextInputField';

type Props = ConnectedProps<typeof connector> & {
  field: SanitizedField<string>;
  handleBlur: (name: string) => void;
  handleChange: (name: string, value: string) => void;
};

export const SenderAddressInputFieldComponent = ({
  field,
  handleBlur,
  handleChange,
  isLulu,
  isLuluOfferSelected,
  isCashfreeOfferSelected,
}: Props) => {
  const i18n = useTranslations();

  let fieldValue: SanitizedField<string> | null = null;
  if (isLulu || isLuluOfferSelected || isCashfreeOfferSelected) {
    fieldValue = {
      ...field,
      hint: i18n.t('senderInformation.address.india.hint'),
    };
  } else {
    fieldValue = field;
  }

  return (
    <TextInputField
      field={fieldValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
    />
  );
};

SenderAddressInputFieldComponent.defaulProps = {
  handleBlur: () => {},
  handleChange: () => {},
  isLulu: false,
  isLuluOfferSelected: false,
  isCashfreeOfferSelected: false,
};

const mapStateToProps = (state: RootState) => ({
  isLulu: isLulu(state),
  isLuluOfferSelected: isLuluOfferSelected(state),
  isCashfreeOfferSelected: isCashfreeOfferSelected(state),
});

const connector = connect(mapStateToProps);

const SenderAddressInputField = connector(SenderAddressInputFieldComponent);

export { SenderAddressInputField };
